import React from 'react'
import { AuthData } from '../../auth/AuthProvider'
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'

function NavLinks() {
    const [user, setUser] = AuthData()
    const navigate = useNavigate();

    const logout = async () => {
        setUser({ auth: false })
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/logout`, {})
        Cookies.remove('token')
        Cookies.remove('mapbox_token')
        navigate('/login', { replace: true })
    }

    return (
        <nav>
            <ul>
                {
                    user.auth ? (
                        <>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            {user.isAdmin && (
                                <>
                                    <li>
                                        <Link to="/data">Data Analysis</Link>
                                    </li>
                                    <li>
                                        <Link to="/QuestionManagement">Question Management</Link>
                                    </li>                                 
                                    <li>
                                        <Link to="/ProjectManagement">Project Management</Link>
                                    </li>
                                </>
                            )}
                            <li>
                                <Link onClick={logout}>Logout</Link>
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <Link to="/login">Login</Link>
                            </li>
                        </>
                    )
                }
            </ul>
        </nav>
    )
}

export default NavLinks
